import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import {useTranslation} from 'react-i18next';

const Modal = (props) => {
    const {t} = useTranslation();

    // Close popup on escape button
    useEffect(() => {
        const close = (e) => {
            if (e.keyCode === 27) {
                props.onClose();
            }
        };
        window.addEventListener('keydown', close);
        return () => window.removeEventListener('keydown', close);
    }, [props]);

    if (!props.showPopup) {
        return null;
    }

    return (
        <div
            className={'modal'}
            onClick={props.backdropClickClose ? props.onClose : null}
        >
            <div className={'modal-card ' + (props.className || '')} onClick={(e) => e.stopPropagation()}>
                <div className={'modal-card-head'}>
                    <>
                        <p className="modal-card-title">{props.title}</p>
                        <button className="delete" aria-label="close" onClick={props.onClose}/>
                    </>
                </div>
                {props.modalCardBody ? (
                    <section className={'modal-card-body'}>
                        {props.modalCardBody}
                    </section>
                ) : (
                    <>
                        <section className={'modal-card-body'}>
                            {props.content}
                        </section>
                        <div className={'modal-card-foot'}>
                            <Button
                                color={props.confirmButtonColor ?? 'danger'}
                                label={props.leaveLabel ? props.leaveLabel : props.label}
                                onClick={props.onDelete}
                            />
                            <Button
                                color="primary"
                                label={props.stayLabel ? props.stayLabel : t('Cancel')}
                                isOutlined={true}
                                onClick={props.onClose}
                            />
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

Modal.propTypes = {
    modalCardBody: PropTypes.node,
    title: PropTypes.string,
    showPopup: PropTypes.bool,
    onClose: PropTypes.func,
    content: PropTypes.node,
    onDelete: PropTypes.func,
    confirmButtonColor: PropTypes.string,
    label: PropTypes.string,
    backdropClickClose: PropTypes.bool,
};

Modal.defaultProps = {
    backdropClickClose: true, // Default value for the new prop
};

export default Modal;
